// extracted by mini-css-extract-plugin
export default {"body":"ingredients_body__tlFtM","conteiner":"ingredients_conteiner__fFQQb","img":"ingredients_img__iw4lo"};